import { RiskAssessmentTemplateResourceType } from "../constants";

export const validResourceType = (type: string) =>
  Object.values(RiskAssessmentTemplateResourceType).includes(
    type as RiskAssessmentTemplateResourceType,
  );
